import { render } from "./MenuUzytkownikow.vue?vue&type=template&id=9a005872&scoped=true"
import script from "./MenuUzytkownikow.vue?vue&type=script&lang=js"
export * from "./MenuUzytkownikow.vue?vue&type=script&lang=js"

import "./_main-menu.scss?vue&type=style&index=0&id=9a005872&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a005872"]])

export default __exports__